<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">专任{{ $store.state.themeTitle }}室人员管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item :label="`${$store.state.themeTitle}室编号`">
          <el-input v-model="formInline.training_no" clearable
            :placeholder="`请输入${$store.state.themeTitle}室编号`"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="人员编号">
          <el-input v-model="formInline.user_no" clearable placeholder="请输入人员编号"></el-input>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input v-model="formInline.user_name" clearable placeholder="请输入人员名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" btnTitle="导入数据"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" width="100" label="姓名">
        </custom-table-column>
        <custom-table-column prop="username" width="160" label="用户名">
        </custom-table-column>
        <!-- <custom-table-column prop="number" width="160" label="工号">
        </custom-table-column> -->
        <custom-table-column prop="training_rooms" min-width="160" :label="`所属${$store.state.themeTitle}室`">
        </custom-table-column>
        <custom-table-column prop="gender_desc" width="100" label="性别">
        </custom-table-column>
        <custom-table-column prop="birthday" width="160" label="出生日期">
        </custom-table-column>
        <custom-table-column prop="expert_type_desc" width="160" label="专家类别">
        </custom-table-column>
        <custom-table-column prop="education_desc" width="160" label="文化程度">
        </custom-table-column>
        <custom-table-column prop="zyjszw_desc" width="160" label="专业技术职务">
        </custom-table-column>
        <custom-table-column prop="domestic_academic_days" width="160" label="国内培训学历教育天数">
        </custom-table-column>
        <custom-table-column prop="domestic_un_academic_days" width="180" label="国内培训非学历教育天数">
        </custom-table-column>
        <custom-table-column prop="international_academic_days" width="160" label="国外培训学历教育天数">
        </custom-table-column>
        <custom-table-column prop="international_un_academic_days" width="180" label="国外培训非学历教育天数">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row, ['display_order', 'school_id'])" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.training_room_user_id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="936px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="220px" class="demo-ruleForm">
        <!-- <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="ruleForm.username" :disabled="type == 'edit'" placeholder="请输入用户名"
            style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入工号/学号" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item :label="`${$store.state.themeTitle}室人员`" prop="person_id">
          <el-select v-model="ruleForm.person_id" clearable @change="handleTeacherChange" filterable :loading="loading"
            remote :remote-method="remoteMethod" placeholder="请选择">
            <el-option v-for="item in users" :key="item.id" :label="item.name" :value="item.id">
              <p>{{ item.name }}</p>
              <p v-if="item.number" class="el-option-tips">工号：{{ item.number }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" multiple filterable style="width:216px;" :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select v-model="ruleForm.gender" style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.sexs" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择" v-model="ruleForm.birthday"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="文化程度" prop="education">
          <el-select v-model="ruleForm.education" filterable style="width:216px;" placeholder="请选择">
            <el-option v-for="item in $store.state.educationLevels" :key="item.code" :label="item.level"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专家类别" prop="expert_type">
          <el-select v-model="ruleForm.expert_type" filterable multiple :multiple-limit="lnum" style="width:216px;"
            placeholder="请选择" @change="handleExTypeChange">
            <el-option v-for="item in $store.state.userTitles" :key="item.code" :label="item.title"
              :value="item.code + ''"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业技能职务" prop="zyjszw">
          <el-cascader v-model="ruleForm.zyjszw" ref="cascader" :show-all-levels="false" :props="props"
            style="width:216px;" clearable :options="$store.state.zyjszwList"></el-cascader>
        </el-form-item>
        <el-form-item label="国内培训学历教育起止日期" prop="domestic_academic_days">
          <!-- <el-input v-model.number="ruleForm.domestic_academic_days" placeholder="请输入" style="width:216px;"></el-input> -->
          <el-date-picker v-model="startEndDates.value1" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="国内培训非学历教育起止日期" prop="domestic_un_academic_days">
          <!-- <el-input v-model.number="ruleForm.domestic_un_academic_days" placeholder="请输入"
            style="width:216px;"></el-input> -->
          <el-date-picker v-model="startEndDates.value2" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="国外培训学历教育起止日期" prop="international_academic_days">
          <!-- <el-input v-model.number="ruleForm.international_academic_days" placeholder="请输入"
            style="width:216px;"></el-input> -->
          <el-date-picker v-model="startEndDates.value3" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="国外培训非学历教育起止日期" prop="international_un_academic_days">
          <!-- <el-input v-model.number="ruleForm.international_un_academic_days" placeholder="请输入"
            style="width:216px;"></el-input> -->
          <el-date-picker v-model="startEndDates.value4" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinImport } from '@/assets/js/mixin/import';
// import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList,mixinImport],
  data() {

    return {
      classRooms: [],
      institutes: [],
      formInline: {
        training_no: '',
        training_name: '',
        user_no: '',
        user_name: '',
      },
      lnum: 0,
      props: {
        value: 'code',
        label: 'name',
        children: 'subcategories',
        emitPath: false
      },
      users: [],
      levell: [1, 2],
      loading: false,
      ruleForm: {
        person_id: '',
        name: '',
        username: '',
        number: '',
        gender: '',
        birthday: '',
        education: '',
        expert_type: [],
        training_room_id: [],
        usertype: 3,
        domestic_academic_days: '',
        domestic_un_academic_days: '',
        international_academic_days: '',
        international_un_academic_days: '',
        zyjszw: ''
      },
      rules: {
        training_room_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        // name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        // username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        // number: [{ required: true, message: '请输入工号/学号', trigger: 'blur' }],
        person_id: [{ required: true, message: `请选择`, trigger: 'change' }],
        gender: [{ required: true, message: `请选择`, trigger: 'change' }],
        birthday: [{ required: true, message: `请选择`, trigger: 'change' }],
        // zyjszw: [{ required: true, message: `请选择`, trigger: 'change' }],
        // education: [{ required: true, message: `请选择`, trigger: 'change' }],
        // expert_type: [{ required: true, message: `请选择`, trigger: 'change' }],
        // domestic_academic_days: [{ required: true, message: '请选择', trigger: 'change' }],
        // domestic_un_academic_days: [{ required: true, message: '请选择', trigger: 'change' }],
        // international_academic_days: [{ required: true, message: '请选择', trigger: 'change' }],
        // international_un_academic_days: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      downloadUrl: 'template/专任实训室人员导入模版.xlsx',
      startEndDates: {
        value1: [],
        value2: [],
        value3: [],
        value4: [],
      },
      action:''
    };
  },
  created() { },
  mounted() {
    this.action = `${this.baseUrlt}api/training/room/user/import`;
    // this.getList();
    // this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getUserTitles');
    this.$store.dispatch('getEducationLevelList');
    this.$store.dispatch('getZyjszwList');
    
  },
  watch: {
    'startEndDates.value1': {
      handler: function (val) {
        this.ruleForm.domestic_academic_days = this.getDaysBetween(val[0], val[1])
      },
      deep: false,
    },
    'startEndDates.value2': {
      handler: function (val) {
        this.ruleForm.domestic_un_academic_days = this.getDaysBetween(val[0], val[1])
      },
      deep: false,
    },
    'startEndDates.value3': {
      handler: function (val) {
        this.ruleForm.international_academic_days = this.getDaysBetween(val[0], val[1])
      },
      deep: false,
    },
    'startEndDates.value4': {
      handler: function (val) {
        this.ruleForm.international_un_academic_days = this.getDaysBetween(val[0], val[1])
      },
      deep: false,
    },
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    getDaysBetween(date1, date2) {
      const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
      const diffInTime = Math.abs(date2 - date1); // 毫秒差
      const diffInDays = Math.floor(diffInTime / oneDay);
      return diffInDays;
    },
    handleExTypeChange(val) {
      if (val.includes("0")) {
        this.ruleForm.expert_type = ["0"]
        this.lnum = 1
      } else {
        this.lnum = 0
      }
    },
    handleTeacherChange(val) {
      this.ruleForm.name = this.$until.getLabelName(this.users, 'id', 'name', val);
      this.ruleForm.username = this.$until.getLabelName(this.users, 'id', 'username', val);
      this.ruleForm.number = this.$until.getLabelName(this.users, 'id', 'number', val);
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
        type: this.$until.getPostsType([4])
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    handleEdit(row, filterArr = ['display_order', 'school_id']) {
      if (row.training_room_id) {
        row.training_room_id = row.training_room_id.split(',');
      }
      if (row.expert_type) {
        row.expert_type = row.expert_type.split(',');
      }
      if ((JSON.stringify(this.users).indexOf(row.id) == -1)) {
        this.users.push({ id: row.id, name: row.name, number: row.number })
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      this.ruleForm.person_id = row.id
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(apply_id, apply_status) {
      let str = '通过';
      if (apply_status == 2) {
        str = '拒绝';
      }
      this.$confirm(`此操作将${str}该实训计划, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.applyStatus(apply_id, apply_status, str);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async applyStatus(plan_id, apply_status, str) {
      let params = { plan_id, apply_status };
      let res = await this.$api.update.applyPlanStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `${str}成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/user/delete`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.training_room_id = params.training_room_id.join(',');
      params.expert_type = params.expert_type.join(',');
      let res = await this.$api.instance.interfaceServer('api/user/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      params.training_room_id = params.training_room_id.join(',');
      params.expert_type = params.expert_type.join(',');

      let res = await this.$api.instance.interfaceServer('api/user/edit', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/room/user/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
